import React from 'react';
import { setDocument, useDocument } from '../../documents/editor/EditorContext';
import BlockOrderSidebarPanel from './ConfigurationPanel/input-panels/BlockOrderSidebarPanel';
export default function BlockOderPanel() {
    const block = useDocument().root;
    if (!block) {
        return React.createElement("p", null, "Block not found");
    }
    const { data, type } = block;
    if (type !== 'EmailLayout') {
        throw new Error('Expected "root" element to be of type EmailLayout');
    }
    return React.createElement(BlockOrderSidebarPanel, { key: "root", data: data, setData: (data) => setDocument({ root: { type, data } }) });
}
//# sourceMappingURL=BlockOderPanel.js.map